import * as React from 'react';

type Props = {
  variant?: 'dashboard' | 'workspace';
  logo?: React.ReactNode;
  leftSlot?: React.ReactNode;      // breadcrumb / project name (workspace)
  centerSlot?: React.ReactNode;    // currently unused, reserved
  rightSlot?: React.ReactNode;     // avatar menu, "New Project" button, autosave
  onLogoClick?: () => void;
};

/**
 * V3Nav — top navigation bar for UBuilder Lite.
 *
 * Two variants per Heni V5 design:
 *
 * **dashboard:** Logo → spacer → [+ New Project] → Avatar dropdown
 * **workspace:** Logo → divider → breadcrumb/project name → spacer →
 *   autosave indicator → [Save as Template] → Avatar dropdown
 *
 * The variant controls layout class; actual content is passed via slots
 * so the nav stays presentational and composable.
 */
const V3Nav: React.SFC<Props> = ({
  variant = 'dashboard',
  logo,
  leftSlot,
  centerSlot,
  rightSlot,
  onLogoClick,
}) => (
  <nav className={`v3-nav ${variant}`}>
    <div className="v3-nav-left">
      <div
        className="v3-nav-logo"
        onClick={onLogoClick}
        role={onLogoClick ? 'button' : undefined}
        tabIndex={onLogoClick ? 0 : undefined}
      >
        {logo || (
          <svg width="120" height="28" viewBox="0 0 120 28">
            <text x="0" y="22" fontFamily="Oswald, sans-serif" fontSize="22" fontWeight="700" fill="#1a2a3a">
              UNIRAC
            </text>
          </svg>
        )}
      </div>
      {variant === 'workspace' && <div className="v3-nav-divider" />}
      {leftSlot}
    </div>
    {centerSlot && <div className="v3-nav-center">{centerSlot}</div>}
    <div className="v3-nav-right">
      {rightSlot}
    </div>
  </nav>
);

export default V3Nav;
